import { DhlDatePicker as NewDatePicker } from "@dhl-official/react-library";
import React from "react";
import PropTypes from "prop-types";

/**
 * Migration wrapper for DatePicker component
 * This component helps transition from old UI library to new UI library
 * by handling prop mapping and maintaining backward compatibility
 */
export const DatePicker = (props) => {
  const {
    id,
    className,
    date,
    disabled,
    variant,
    displayFormat,
    onChange,
    validation,
    children,
    ...rest
  } = props;

  const newProps = {
    ...rest,
    id,
    className,
    value: date,
    isDisabled: disabled,
    label: variant?.label,
    labelType: variant?.type,
    format: displayFormat,
    onDhlChange: onChange,
    validation: validation
      ? {
          message: validation.message,
          type: validation.type,
        }
      : undefined,
  };

  return <NewDatePicker {...newProps}>{children}</NewDatePicker>;
};

DatePicker.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  date: PropTypes.any,
  disabled: PropTypes.bool,
  variant: PropTypes.object,
  displayFormat: PropTypes.string,
  onChange: PropTypes.func,
  validation: PropTypes.any,
  children: PropTypes.node,
};
